module.exports = __webpack_public_path__ + "static/media/iot-solution03.b6eef97e.jpg";